/* Update cart items */
if (!customElements.get("cart-items")) {
  class CartItems extends HTMLElement {
    constructor() {
      super();

      this.init();
    }

    init() {
      this.lineItemStatusElement = document.getElementById(
        "shopping-cart-line-item-status"
      );
      this.currentItemCount = Array.from(
        this.querySelectorAll('[name="updates[]"]')
      ).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value),
        0
      );

      this.debouncedOnChange = debounce((event) => {
        if (event.target != document.getElementById("Cart-note")) {
          this.onChange(event);
        }
      }, 300);

      this.addEventListener("change", this.debouncedOnChange.bind(this));

      this.handleCoolProduct();
    }

    onChange(event) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name")
      );
    }

    /**
     * handleCoolProduct
     * @description Handles the cool product logic. Async.
     * @returns {Void}
     */
    async handleCoolProduct(cartData = null) {
      if (!coolingProductObject) return;

      this.coolingProductID = coolingProductObject.id;
      const data = cartData ? cartData : await this.fetchCart();

      // Check if there is a coolingProductId. if not, return;
      if (!this.coolingProductID) return;

      const coolboxStatus = this.isCoolBoxInCart(data);
      const coolboxNeeded = this.isCoolBoxNeeded(data);

      // Destructure coolboxStatus for cleaner code
      const { exists, count } = coolboxStatus;

      // If there is a product requiring a coolbox in the cart and the coolbox is not already in the cart, add the coolbox to the cart
      if (coolboxNeeded && !exists) {
        // add
        this.enableLoading();
        await this.addCoolboxToCart();
        await this.refreshCartItems();
      }
      // If there is a product requiring a coolbox and more than one coolbox, remove extras
      else if (coolboxNeeded && count > 1) {
        // Remove extra coolboxes, keeping only one
        this.enableLoading();
        await this.normalizeCoolelementsInCart();
        await this.refreshCartItems();
      }
      // If there is no product requiring a coolbox but coolboxes exist, remove them all
      else if (!coolboxNeeded && exists) {
        this.enableLoading();
        await this.deleteCoolboxFromCart();
        await this.refreshCartItems();
      }
    }

    /**
     * fetchCart
     * @returns {Object} Shopify /cart.js data.
     */
    async fetchCart() {
      // Check if the product is already in the cart
      const response = await fetch(window.Shopify.routes.root + "cart.js");
      const data = await response.json();
      return data;
    }

    /**
     * isCoolBoxNeeded
     * @description Check if the coolbox is needed for 1 of the products in the cart.
     * @param {Object} data
     */
    isCoolBoxNeeded(data = null) {
      const cartItems = data.items;
      let coolboxNeeded = false;

      // Iterate over the cart items and check the properties
      for (let i = 0; i < cartItems.length; i++) {
        const item = cartItems[i];
        // Check if this product needs the coolbox
        if ("properties" in item && item.properties !== null) {
          if (item.properties._coolbox === "true") {
            coolboxNeeded = true;
            break;
          }
        }
      }
      return coolboxNeeded;
    }

    /**
     * isCoolBoxInCart
     * @description Checks if the coolbox is already in the cart.
     * @param {Object} data
     * @returns {Boolean}
     */
    isCoolBoxInCart(data = null) {
      if (!data) {
        throw new Error("No data provided");
      }
      const cartItems = data.items;
      // Check if coolbox product is already in cart and count how many
      const coolboxItems = cartItems.filter(
        (item) => item.variant_id === this.coolingProductID
      );

      return {
        exists: coolboxItems.length > 0,
        count: coolboxItems.length
      };
    }

    /**
     * addCoolboxToCart
     */
    async addCoolboxToCart() {
      const formData = {
        items: [
          {
            id: this.coolingProductID,
            quantity: 1,
            properties: {
              _cooling_box: true,
            },
          },
        ],
      };
      // Product is not in the cart, add it
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        ...fetchConfig(),
        body: JSON.stringify(formData),
      });
      const data = await response.json();
    }

    /**
     * deleteCoolboxFromCart
     */
    async deleteCoolboxFromCart() {
      try {
        const response = await fetch(
          window.Shopify.routes.root + "cart/update.js",
          {
            ...fetchConfig(),
            body: JSON.stringify({
              updates: {
                [this.coolingProductID]: 0,
              },
            }),
          }
        );
        const test = await response.json();
        return test;
      } catch (error) {
        console.error("Error:", error);
      }
    }

    /**
     * refreshCartItems
     * @description Fetches and replaces the cart-items web component completely.
     */
    async refreshCartItems() {
      if (!document.querySelector("cart-items")) return;
      const sectionId = this.dataset.id;

      try {

        let response = await fetch(`/cart?section_id=${sectionId}`);
        let selector = 'cart-items';
        let container_selector = '.container__content';
        if (sectionId.indexOf('cart-drawer') > -1) {
          response = await fetch(`/?section_id=${sectionId}`);
          selector = '[data-cart-drawer]';
          container_selector = '[data-cart-drawer-wrapper]';
        }
        const html = await response.text();

        const newCartItems = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector)
          .querySelector(container_selector).innerHTML;

        document
          .querySelector(selector)
          .querySelector(container_selector).innerHTML = newCartItems;

        this.disableLoading();
        document.querySelector('[data-cart-loader-active="show"]')
          ?.classList.add("hidden");
        document
          .querySelector('[data-cart-loader-active="hidden"]')
          ?.classList.remove("hidden");

        this.closeButtons = document.querySelectorAll('[data-cart-button-close]');
        this.closeButtons.forEach((btn) => btn.addEventListener('click', this.close.bind(this)));

      } catch (error) {
        console.log(error);
      }
    }

    /**
     * normalizeCoolelementsInCart
     * @description Ensures there is exactly one cooling element in the cart
     */
    async normalizeCoolelementsInCart() {
      // First, remove all cooling elements
      await this.deleteCoolboxFromCart();

      // Then add exactly one
      await this.addCoolboxToCart();
    }

    close() {
      document.querySelector('body').classList.remove('cart-drawer-is-open');
    }

    getSectionsToRender() {
      return [
        {
          id: "main-cart-items",
          section: document.getElementById("main-cart-items").dataset.id,
          selector: ".js-cart-item-contents",
        },
        {
          id: "main-cart-footer",
          section: document.getElementById("main-cart-footer").dataset.id,
          selector: ".js-cart-footer-contents",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: "[data-cart-icon-bubble]",
        },
      ];
    }

    updateQuantity(line, quantity, name) {
      this.enableLoading(line);

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.json();
        })
        .then((parsedState) => {
          this.classList.toggle("cart-is-empty", parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });

          //this.updateLiveRegions(line, parsedState.item_count);
          document
            .getElementById(`CartItem-${line}`)
            ?.querySelector(`[name="${name}"]`)
            ?.focus();
          this.disableLoading();

          this.handleCoolProduct(parsedState);
        })
        .catch((error) => {
          document
            .querySelector('[data-cart-loader-active="show"]')
            ?.classList.add("hidden");
          document
            .querySelector('[data-cart-loader-active="hidden"]')
            ?.classList.remove("hidden");
          document.getElementById("cart-errors").textContent =
            window.cartStrings.error;
          this.disableLoading();
        });
    }

    // show error texts, should not be deleted.
    updateLiveRegions(line, itemCount) {
      if (this.currentItemCount === itemCount) {
        document
          .getElementById(`Line-item-error-${line}`)
          .querySelector(".cart-item__error-text").innerHTML =
          window.cartStrings.quantityError.replace(
            "[quantity]",
            document.getElementById(`Quantity-${line}`).value
          );
      }

      this.currentItemCount = itemCount;
      this.lineItemStatusElement.setAttribute("aria-hidden", true);

      const cartStatus = document.getElementById("cart-live-region-text");
      cartStatus.setAttribute("aria-hidden", false);

      setTimeout(() => {
        cartStatus.setAttribute("aria-hidden", true);
      }, 1000);
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      document
        .querySelector("cart-items")
        .classList.add("cart-items-is-loading");
      document
        .querySelector('[data-cart-loader-active="show"]')
        ?.classList.remove("hidden");
      document
        .querySelector('[data-cart-loader-active="hidden"]')
        ?.classList.add("hidden");
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute("aria-hidden", false);
    }

    disableLoading() {
      document
        .querySelector("cart-items")
        .classList.remove("cart-items-is-loading");
    }
  }
  customElements.define("cart-items", CartItems);
}

/* Remove item from the cart  */
if (!customElements.get("cart-remove-button")) {
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", (event) => {
        event.preventDefault();
        this.closest("cart-items").updateQuantity(this.dataset.index, 0);
      });
    }
  }
  customElements.define("cart-remove-button", CartRemoveButton);
}

/* Update the cart note */
if (!customElements.get("cart-note")) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        "change",
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }
  customElements.define("cart-note", CartNote);
}
